import React, { useState, useMemo } from 'react';
import ReinnoireCard from '../Shared/ReinnoireCard';
import DateField from '../Shared/DateField';
import ProceduraFileSection from '../Shared/ProceduraFileSection';
import { FilterPill } from '../Shared/FilterPill';
import './Tracker.css';


export const CLASE_NISA = [
  [1,'Produse chimice pentru industrie si stiinta'],
  [2,'Vopsele, lacuri, coloranti, rasini'],
  [3,'Cosmetice, parfumerie, produse de curatare'],
  [4,'Uleiuri si grasimi industriale, combustibili, lumanari'],
  [5,'Produse farmaceutice, de uz medical si veterinar'],
  [6,'Metale comune, materiale de constructie metalice'],
  [7,'Masini, masini-unelte, motoare (nu pt. vehicule)'],
  [8,'Scule si instrumente de mana actionate manual'],
  [9,'Aparate stiintifice, electrice, software, IT'],
  [10,'Aparate si instrumente medicale, chirurgicale, dentare'],
  [11,'Aparate de iluminat, incalzire, racire, gatit, ventilatie'],
  [12,'Vehicule; aparate de locomotie terestra, aeriana, navala'],
  [13,'Arme de foc, munitie, explozibili, artificii'],
  [14,'Metale pretioase, bijuterii, ceasuri'],
  [15,'Instrumente muzicale'],
  [16,'Hartie, carton, tiparituri, papetarie'],
  [17,'Cauciuc, materiale plastice semiprelucrate, izolatoare'],
  [18,'Piele si imitatii, bagaje, selarie, umbrele'],
  [19,'Materiale de constructie nemetalice'],
  [20,'Mobilier, oglinzi, rame; produse din lemn, pluta'],
  [21,'Ustensile si recipiente de menaj si bucatarie, sticlarie'],
  [22,'Franghii, plase, corturi, fibre textile brute'],
  [23,'Fire de uz textil'],
  [24,'Tesaturi si produse textile, lenjerie de casa'],
  [25,'Imbracaminte, incaltaminte, articole pt. acoperirea capului'],
  [26,'Dantele, broderii, panglici, nasturi, accesorii par'],
  [27,'Covoare, presuri, linoleum, tapet'],
  [28,'Jocuri, jucarii, articole de sport, decoratiuni Craciun'],
  [29,'Carne, peste, lactate, conserve, uleiuri alimentare'],
  [30,'Cafea, ceai, faina, paine, patiserie, condimente'],
  [31,'Produse agricole si horticole brute, animale vii, plante'],
  [32,'Bere, ape minerale, bauturi nealcoolice, sucuri'],
  [33,'Bauturi alcoolice (cu exceptia berii)'],
  [34,'Tutun, articole pentru fumatori, chibrituri'],
  [35,'Publicitate, management afaceri, comert cu amanuntul/online'],
  [36,'Servicii financiare, asigurari, imobiliare'],
  [37,'Constructii, reparatii, servicii de instalatii'],
  [38,'Telecomunicatii'],
  [39,'Transport, ambalare si depozitare, organizare calatorii'],
  [40,'Prelucrarea si tratarea materialelor'],
  [41,'Educatie, instruire, divertisment, activitati sportive/culturale'],
  [42,'Servicii stiintifice si tehnologice, IT, design, software'],
  [43,'Servicii de alimentatie publica, cazare temporara'],
  [44,'Servicii medicale, veterinare, igiena, infrumusetare'],
  [45,'Servicii juridice, de securitate, servicii personale'],
];

/* ── Helpers ── */
const todayMid = () => { const d = new Date(); d.setHours(0,0,0,0); return d; };
const parseISO = (s) => (s ? new Date(s + 'T00:00:00') : null);
const addYears = (d, y) => { const x = new Date(d); x.setFullYear(x.getFullYear() + y); return x; };
const fmtRO = (d) => d ? d.toLocaleDateString('ro-RO', { day:'2-digit', month:'2-digit', year:'numeric' }) : '—';
const daysLeft = (d) => d ? Math.ceil((d - todayMid()) / 86400000) : null;

/* ── emptyRecord export ── */
export function emptyRecord() {
  return {
    denumire: '',
    tip: 'verbala',
    color: 'abn',
    clase: {},
    bazaCerere: 'cerere',
    numarBaza: '',
    oficiuBaza: '',
    dataBaza: '',
    tariDesemnate: '',
    depusa: false,
    achitat_taxa_depunere: false,
    numar: '',
    dataDepunere: '',
    dataTransmisWIPO: '',
    dataPublicareGazette: '',
    dataInregistrare: '',
    dataExpirare: '',
    certificatPrimit: false,
    marcaInregistrata: false,
    viennaCode: '',
    transmisClient: false,
    taxeWipo: '',
    observatii: '',
  };
}

/* ── Status / timeline ── */
function deriveStatus(r) {
  const expirare = parseISO(r.dataInregistrare) ? addYears(parseISO(r.dataInregistrare), 10) : null;
  const registered = !!(r.marcaInregistrata || r.dataInregistrare);

  const steps = [
    { key:'depunere',  label:'Depunere la oficiul de origine', done: registered || !!r.depusa,               date: parseISO(r.dataDepunere) },
    { key:'transmis',  label:'Transmisa la WIPO',              done: registered || !!r.dataTransmisWIPO,     date: parseISO(r.dataTransmisWIPO) },
    { key:'gazette',   label:'Publicare WIPO Gazette',         done: registered || !!r.dataPublicareGazette, date: parseISO(r.dataPublicareGazette) },
    { key:'examinare', label:'Examinare tari desemnate',       done: registered || !!r.dataInregistrare,     date: null },
    { key:'inreg',     label:'Inregistrare internationala',    done: registered || !!r.dataInregistrare,     date: parseISO(r.dataInregistrare) },
    { key:'client',    label:'Transmis client',                done: r.transmisClient,               date: null },
  ];

  let alert;
  if (registered) {
    alert = (r.certificatPrimit && !r.transmisClient)
      ? { label:'De transmis certificatul catre client', sev:'act' }
      : { label:'Marca inregistrata', sev:'done' };
  } else if (!r.depusa) {
    alert = { label:'In pregatire — de depus', sev:'neutral' };
  } else if (!r.dataTransmisWIPO) {
    alert = { label:'Asteptare transmitere la WIPO', sev:'info' };
  } else if (!r.dataPublicareGazette) {
    alert = { label:'Asteptare publicare in WIPO Gazette', sev:'info' };
  } else if (!r.dataInregistrare) {
    alert = { label:'Examinare tari desemnate — 12–18 luni de la publicare', sev:'watch' };
  } else if (!r.certificatPrimit) {
    alert = { label:'De obtinut certificatul de inregistrare internationala', sev:'act' };
  } else if (!r.transmisClient) {
    alert = { label:'De transmis certificatul catre client', sev:'act' };
  } else {
    alert = { label:'Procedura finalizata', sev:'done' };
  }

  if (alert.date) {
    const dl = daysLeft(alert.date);
    alert.daysLeft = dl;
    if (dl < 0) alert.sev = 'overdue';
  }

  if (expirare && (alert.sev === 'done' || alert.sev === 'act')) {
    const dl = daysLeft(expirare);
    if (dl <= 365) {
      alert = { label: dl < 0 ? 'Inregistrare expirata — reinnoire necesara' : 'Inregistrare expira in curand — reinnoire necesara', date: expirare, daysLeft: dl, sev: dl < 0 ? 'overdue' : 'watch' };
    }
  }

  return { steps, alert, expirare };
}

/* ════════════════════════ Component ════════════════════════ */
export default function MarcaWIPOTracker({ data, onChange, procId, showToast, pendingFiles, onPendingFilesChange }) {
  const [r, setR] = useState(data);

  const set = (patch) => {
    const next = { ...r, ...patch };
    setR(next);
    onChange(next);
  };

  const status = useMemo(() => deriveStatus(r), [r]);
  const isVerbala = r.tip === 'verbala';

  const toggleClasa = (nr) => {
    const c = { ...r.clase };
    if (c[nr] !== undefined) delete c[nr]; else c[nr] = '';
    set({ clase: c });
  };
  const setTermeni = (nr, val) => set({ clase: { ...r.clase, [nr]: val } });

  return (
    <div className="tracker">
      <AlertBanner status={status} />
      <Timeline steps={status.steps} />

      {/* Identificare */}
      <TrackerCard title="Identificarea marcii">
        <div className="f-row">
          <div className="field">
            <label>Denumire marca</label>
            <input type="text" value={r.denumire} onChange={e => set({ denumire: e.target.value })} placeholder="ex: Aurora Style" />
          </div>
          <div className="field">
            <label>Tip marca</label>
            <FilterPill value={r.tip} onChange={e => set({ tip: e.target.value })}>
              <option value="verbala">Verbala</option>
              <option value="combinata">Combinata (cuvant + imagine)</option>
              <option value="figurativa">Figurativa (logo/imagine)</option>
              <option value="stilizata">Caractere Stilizate</option>
              <option value="tridimensionala">Tridimensionala (3D)</option>
              <option value="sonora">Sonora</option>
              <option value="alt">Alt tip</option>
            </FilterPill>
          </div>
        </div>
        {!isVerbala && (
          <div className="field">
            <label>Fisiere de reprezentare <span className="f-hint">— logo, imagine, fisier 3D etc.</span></label>
            <ProceduraFileSection procId={procId} showToast={showToast} pendingFiles={pendingFiles} onPendingFilesChange={onPendingFilesChange} />
          </div>
        )}
        {!isVerbala && (
          <div className="field">
            <label>Coduri Vienna <span className="f-hint">— separate prin virgula, ex: 05.03.13, 26.03.01</span></label>
            <input type="text" value={r.viennaCode || ''} onChange={e => set({ viennaCode: e.target.value })} className="mono" placeholder="ex: 05.03.13, 26.04.07" />
          </div>
        )}
        <div className="field">
          <label>Culoare {isVerbala && <span className="f-hint">— marca verbala este standard (alb-negru)</span>}</label>
          <SegControl
            value={isVerbala ? 'abn' : r.color}
            disabled={isVerbala}
            onChange={v => set({ color: v })}
            options={[['abn','Alb-negru'],['color','Color']]}
          />
        </div>
      </TrackerCard>

      {/* Baza cererii */}
      <TrackerCard title="Baza internationala (marca de origine)">
        <p className="f-hint mb8">Inregistrarea WIPO/Madrid trebuie sa se bazeze pe o cerere sau inregistrare nationala/regionala existenta (de regula OSIM sau EUIPO).</p>
        <div className="f-row">
          <div className="field">
            <label>Baza cererii</label>
            <SegControl value={r.bazaCerere} onChange={v => set({ bazaCerere: v })} options={[['cerere','Cerere depusa'],['inregistrare','Marca inregistrata']]} />
          </div>
          <div className="field">
            <label>Nr. marca de baza</label>
            <input type="text" value={r.numarBaza} onChange={e => set({ numarBaza: e.target.value })} className="mono" />
          </div>
          <div className="field">
            <label>Oficiu de baza</label>
            <input type="text" value={r.oficiuBaza} onChange={e => set({ oficiuBaza: e.target.value })} placeholder="ex: OSIM, EUIPO" />
          </div>
          <div className="field">
            <label>Data marcii de baza</label>
            <DateField value={r.dataBaza} onChange={v => set({ dataBaza: v })} />
          </div>
        </div>
        <div className="field">
          <label>Tari desemnate <span className="f-hint">— separate prin virgula</span></label>
          <input type="text" value={r.tariDesemnate} onChange={e => set({ tariDesemnate: e.target.value })} placeholder="ex: US, CN, JP, GB" />
        </div>
      </TrackerCard>

      {/* Clase Nisa */}
      <TrackerCard title={`Clase Nisa (${Object.keys(r.clase).length} selectate)`} collapsible defaultOpen={false}>
        <p className="f-hint mb8">Bifeaza clasele si lipeste lista de produse/servicii per clasa.</p>
        <div className="clase-grid">
          {CLASE_NISA.map(([nr, titlu]) => {
            const sel = r.clase[nr] !== undefined;
            return (
              <div key={nr} className={`clasa-item${sel ? ' clasa-sel' : ''}`}>
                <label className="clasa-label">
                  <input type="checkbox" checked={sel} onChange={() => toggleClasa(nr)} />
                  <span className="clasa-nr">{String(nr).padStart(2,'0')}</span>
                  <span className="clasa-titlu">{titlu}</span>
                </label>
                {sel && (
                  <textarea
                    value={r.clase[nr]}
                    onChange={e => setTermeni(nr, e.target.value)}
                    placeholder={`Produse/servicii pt. clasa ${nr}…`}
                    rows={2}
                    className="clasa-textarea"
                  />
                )}
              </div>
            );
          })}
        </div>
      </TrackerCard>

      {/* Calcul taxe */}
      <TrackerCard title="Taxe WIPO">
        <div className="field">
          <label>Valoare taxe oficiale</label>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <input
              type="number"
              min="0"
              step="any"
              value={r.taxeWipo}
              onChange={e => set({ taxeWipo: e.target.value })}
              placeholder="ex: 653"
              style={{ maxWidth: 160 }}
            />
            <span style={{ fontWeight: 600, color: 'var(--muted)' }}>CHF</span>
          </div>
          <span className="f-hint">Folositi calculatorul oficial WIPO (Fee Calculator) pentru totalul exact per tara.</span>
        </div>
      </TrackerCard>

      {/* Depunere + monitorizare */}
      <TrackerCard title="Depunere si monitorizare">
        <label className="check-label">
          <input type="checkbox" checked={r.depusa} onChange={e => set({ depusa: e.target.checked })} />
          <strong>Cererea internationala a fost depusa</strong>
        </label>
        <p className="f-hint mb8" style={{ marginLeft: 22 }}>La bifare si introducerea numarului, porneste urmarirea etapelor si a termenelor.</p>

        {r.depusa && (
          <div className="dep-section">
            <label className="check-label mb8">
              <input type="checkbox" checked={!!r.achitat_taxa_depunere} onChange={e => set({ achitat_taxa_depunere: e.target.checked })} />
              <strong>Marca a fost achitata</strong>
              <span className="f-hint" style={{ marginLeft: 6 }}>— termen 90 zile de la data depunerii</span>
            </label>
            <div className="f-row">
              <div className="field">
                <label>Nr. inregistrare internationala</label>
                <input type="text" value={r.numar} onChange={e => set({ numar: e.target.value })} placeholder="ex. 1xxxxxx" className="mono" />
              </div>
              <div className="field">
                <label>Data depunerii (la oficiul de origine)</label>
                <DateField value={r.dataDepunere} onChange={v => set({ dataDepunere: v })} />
              </div>
            </div>

            <div className="tr-divider">Transmitere &amp; publicare</div>

            <div className="f-row">
              <div className="field">
                <label>Data transmiterii la WIPO</label>
                <DateField value={r.dataTransmisWIPO} onChange={v => set({ dataTransmisWIPO: v })} />
              </div>
              <div className="field">
                <label>Data publicarii in WIPO Gazette</label>
                <DateField value={r.dataPublicareGazette} onChange={v => set({ dataPublicareGazette: v })} />
                <span className="f-hint">Porneste perioada de examinare a tarilor desemnate (12–18 luni).</span>
              </div>
            </div>

            <div className="tr-divider">Inregistrare &amp; finalizare</div>

            <div className="field">
              <label>Data inregistrarii internationale</label>
              <DateField value={r.dataInregistrare} onChange={v => set({ dataInregistrare: v })} />
            </div>
            <div className="field">
              <label>Data expirarii</label>
              <DateField value={r.dataExpirare || ''} onChange={v => set({ dataExpirare: v })} />
            </div>

            {status.expirare && (
              <div className="f-row">
                <DeadlineChip label="Expirare inregistrare (10 ani)" date={status.expirare} act />
              </div>
            )}

            <label className="check-label">
              <input type="checkbox" checked={r.certificatPrimit} onChange={e => set({ certificatPrimit: e.target.checked })} />
              Certificatul de inregistrare internationala a fost primit
            </label>
            <label className={`check-label${!r.certificatPrimit ? ' disabled' : ''}`}>
              <input type="checkbox" disabled={!r.certificatPrimit} checked={r.transmisClient} onChange={e => set({ transmisClient: e.target.checked })} />
              Certificatul a fost transmis catre client
            </label>
            <label className="check-label">
              <input type="checkbox" checked={r.marcaInregistrata || false} onChange={e => set({ marcaInregistrata: e.target.checked })} />
              Statusul marcii este inregistrata
            </label>
          </div>
        )}
      </TrackerCard>

            {/* ── Reinnoire ── */}
      <ReinnoireCard r={r} set={set} TrackerCard={TrackerCard} />

      {/* Observatii */}
      <TrackerCard title="Observatii interne">
        <textarea className="tr-textarea" value={r.observatii} onChange={e => set({ observatii: e.target.value })} rows={3} placeholder="Note de dosar…" />
      </TrackerCard>

      {/* Documente inregistrare */}
      <TrackerCard title="Documente inregistrare">
        <ProceduraFileSection
          procId={procId}
          showToast={showToast}
          pendingFiles={pendingFiles}
          onPendingFilesChange={onPendingFilesChange}
          tipOptions={['Duplicat Cerere inregistrare', 'Copie Certificat Inregistrare']}
          keyPrefix="inreg"
        />
      </TrackerCard>
    </div>
  );
}

/* ── Sub-components ── */
function AlertBanner({ status }) {
  const { alert } = status;
  return (
    <div className={`tr-alert sev-${alert.sev}`}>
      <strong>{alert.label}</strong>
      {alert.date && (
        <span className="tr-alert-date">
          Termen: {fmtRO(alert.date)}
          {typeof alert.daysLeft === 'number' && (
            alert.daysLeft < 0
              ? ` · depasit cu ${Math.abs(alert.daysLeft)} zile`
              : ` · ${alert.daysLeft} zile ramase`
          )}
        </span>
      )}
    </div>
  );
}

function Timeline({ steps }) {
  const activeIdx = steps.findIndex(s => !s.done);
  return (
    <div className="tr-timeline">
      {steps.map((s, i) => {
        const isActive = i === activeIdx;
        const done = s.done;
        return (
          <React.Fragment key={s.key}>
            {i > 0 && <span className={`tl-line${done || steps[i-1].done ? ' tl-line-done' : ''}`} />}
            <div className="tl-step">
              <span className={`tl-dot${done ? ' done' : isActive ? ' active' : ''}`}>
                {done ? '✓' : i + 1}
              </span>
              <span className={`tl-label${isActive ? ' active' : done ? ' done' : ''}`}>{s.label}</span>
              {s.date && <span className="tl-date">{fmtRO(s.date)}</span>}
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
}

function TrackerCard({ title, badge, children, collapsible = false, defaultOpen = true }) {
  const [open, setOpen] = useState(defaultOpen);
  const isOpen = !collapsible || open;
  return (
    <div className="tr-card">
      <div
        className={`tr-card-head${collapsible ? ' tr-card-head-toggle' : ''}`}
        onClick={collapsible ? () => setOpen(o => !o) : undefined}
      >
        <span className="tr-card-title">{title}</span>
        <div className="tr-card-head-right">
          {badge && <span className="tr-badge">{badge}</span>}
          {collapsible && <span className={`tr-card-arrow${isOpen ? ' tr-card-arrow-open' : ''}`}>›</span>}
        </div>
      </div>
      {isOpen && <div className="tr-card-body">{children}</div>}
    </div>
  );
}

function SegControl({ value, onChange, options, disabled }) {
  return (
    <div className={`seg-ctrl${disabled ? ' seg-disabled' : ''}`}>
      {options.map(([v, label]) => (
        <button key={v} type="button" disabled={disabled}
          className={`seg-btn${value === v ? ' seg-active' : ''}`}
          onClick={() => !disabled && onChange(v)}>
          {label}
        </button>
      ))}
    </div>
  );
}

function DeadlineChip({ label, date, act }) {
  const dl = daysLeft(date);
  const overdue = dl < 0;
  const soon = dl >= 0 && dl <= 14;
  const cls = overdue ? 'chip-overdue' : (act && soon) ? 'chip-act' : 'chip-neutral';
  return (
    <div className={`deadline-chip ${cls}`}>
      <span>{label}</span>
      <span>{fmtRO(date)} · {overdue ? `${Math.abs(dl)}z depasit` : `${dl}z`}</span>
    </div>
  );
}
